import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";

import PublicLayout from "@/components/PublicLayout";
import AdminLayout from "@/components/AdminLayout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import { EventsList, EventDetail } from "@/pages/Events";
import { BlogList, BlogDetail } from "@/pages/Blog";
import { ShopList, ProductDetail } from "@/pages/Shop";
import Gallery from "@/pages/Gallery";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Results from "@/pages/Results";

import AdminLogin from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import BannersAdmin from "@/pages/admin/Banners";
import EventsAdmin from "@/pages/admin/Events";
import MatchResultsAdmin from "@/pages/admin/MatchResults";
import BlogsAdmin from "@/pages/admin/Blogs";
import ProductsAdmin from "@/pages/admin/Products";
import GalleryAdmin from "@/pages/admin/Gallery";
import StatsAdmin from "@/pages/admin/Stats";
import NotificationsAdmin from "@/pages/admin/Notifications";
import InquiriesAdmin from "@/pages/admin/Inquiries";
import SubscribersAdmin from "@/pages/admin/Subscribers";
import MessagesAdmin from "@/pages/admin/Messages";
import SEOAdmin from "@/pages/admin/SEO";
import SettingsAdmin from "@/pages/admin/Settings";

export default function App() {
  return (
    <SettingsProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            {/* Admin login (no layout) */}
            <Route path="/admin/login" element={<AdminLogin />} />

            {/* Admin protected */}
            <Route element={<ProtectedRoute />}>
              <Route element={<AdminLayout />}>
                <Route path="/admin" element={<Dashboard />} />
                <Route path="/admin/banners" element={<BannersAdmin />} />
                <Route path="/admin/events" element={<EventsAdmin />} />
                <Route path="/admin/match-results" element={<MatchResultsAdmin />} />
                <Route path="/admin/blogs" element={<BlogsAdmin />} />
                <Route path="/admin/products" element={<ProductsAdmin />} />
                <Route path="/admin/gallery" element={<GalleryAdmin />} />
                <Route path="/admin/stats" element={<StatsAdmin />} />
                <Route path="/admin/notifications" element={<NotificationsAdmin />} />
                <Route path="/admin/inquiries" element={<InquiriesAdmin />} />
                <Route path="/admin/subscribers" element={<SubscribersAdmin />} />
                <Route path="/admin/messages" element={<MessagesAdmin />} />
                <Route path="/admin/seo" element={<SEOAdmin />} />
                <Route path="/admin/settings" element={<SettingsAdmin />} />
              </Route>
            </Route>

            {/* Public site */}
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/events" element={<EventsList />} />
              <Route path="/events/:slug" element={<EventDetail />} />
              <Route path="/results" element={<Results />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogDetail />} />
              <Route path="/shop" element={<ShopList />} />
              <Route path="/shop/:slug" element={<ProductDetail />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </SettingsProvider>
  );
}
